import React from 'react';
import { Flex } from 'components';
import { TenantLeaseInfo } from 'graphql-query-contracts';
import { useTranslation } from 'react-i18next';
import { SourceTypeLabel } from '../../../../../../../type-maps/source-type-label.map';

export const ViewTenantLeaseItem = ({ lease }: { lease: TenantLeaseInfo }) => {
  const { t } = useTranslation();

  const { suite, source, leaseId } = lease;

  if (!suite?.name) {
    return null;
  }

  const getLeaseIdToDisplay = () => {
    const sourceTypeLabel = source?.sourceType
      ? SourceTypeLabel[source.sourceType]
      : '';

    return `${leaseId} [${sourceTypeLabel}]`;
  };

  return (
    <Flex direction="column">
      <b>{suite.name}</b>
      {leaseId && leaseId.trim() ? (
        <Flex direction="row" gap={2}>
          <span>
            {t(
              'web.admin.channel.settings.tenantManagement.tenant.details.viewLeases.externalLeaseID'
            )}
          </span>
          <span>{getLeaseIdToDisplay()}</span>
        </Flex>
      ) : null}
    </Flex>
  );
};
